export default [
    {
        path: 'atendimento-recepcao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-atendimento-recepcao' */
            '@/views/pronto-atendimento/atendimento-recepcao/Index'
        ),
        redirect: 'atendimento-recepcao/index',
        children: [
            {
                name: 'pronto-atendimento-atendimento-recepcao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-recepcao' */
                    '@/views/pronto-atendimento/atendimento-recepcao/List.vue'
                ),
            },
            {
                name: 'pronto-atendimento-atendimento-recepcao-paciente',
                path: 'paciente',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-recepcao' */
                    '@/views/pronto-atendimento/atendimento-recepcao/ListPaciente.vue'
                ),
            },
            {
                name: 'pronto-atendimento-atendimento-recepcao-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-recepcao' */
                    '@/views/pronto-atendimento/atendimento-recepcao/Form.vue'
                ),
            },
        ],
    },
]